module.exports = __webpack_public_path__ + "img/wood.d91ae1fc.png";